import React from "react";

import { PageHeader } from "../../common/ui/layout/header/PageHeader";
import { TvSeriesDashboardBreadcrumb } from "./TvSeriesDashboardBreadcrumb";

export const TvSeriesDashboardHeader: React.FunctionComponent = () => {
    return (
        <PageHeader>
            <TvSeriesDashboardBreadcrumb />
        </PageHeader>
    );
};
